/** This function will create floating labels on
 * String, Textarea and Email string input fields
 * and only fires when a placeholder is set.
 */

export default function formFloatingLabels() {
    const formTextInput = document.querySelectorAll('.sq-form-question-text');
    const formEmailInput = document.querySelectorAll('.sq-form-question-email-address');

    if (formTextInput) {
        formTextInput.forEach((textInput) => {
            const textField = textInput.querySelector('input[type="text"]');
            const textFieldLabel = textInput.querySelector('label');

            // input[type="text"] Case
            if (textField && textField !== null && (textField.value == null || textField.value == '' || textField.value !== undefined) && textField.placeholder) {
                // Equivalent to :placeholder-shown
                textFieldLabel.classList.add('placeholder--shown');
                textField.style.borderColor = '#727683';
            } else {
                // Reset styles when placeholder is not shown
                textFieldLabel.classList.remove('placeholder--shown');
                textFieldLabel.classList.add('placeholder--none');
            }

            // If there is a value after submission and validation, don't fire floating label
            if (textField !== null && textField.value.trim() !== '') {
                textFieldLabel.classList.add('label--focus');
                textFieldLabel.style.fontSize = '12px';
                textFieldLabel.style.lineHeight = '1';
                textField.style.borderColor = '#0b1c46';
            }

            function updateTextFieldLabel() {
                if (((textField !== null && textField.value.trim() !== '') || document.activeElement === textField) && textField.placeholder !== '') {
                    textFieldLabel.classList.add('label--focus');
                    textFieldLabel.classList.remove('placeholder--shown');
                    textFieldLabel.style.fontSize = '12px';
                    textField.style.borderColor = '#0b1c46';
                }
            }

            if (textField !== null) {
                // Event listeners
                textField.addEventListener('focus', updateTextFieldLabel);
                textField.addEventListener('input', updateTextFieldLabel);
                textField.addEventListener('blur', updateTextFieldLabel);
            }

            // textarea Case
            const textAreaField = textInput.querySelector('textarea');

            if (textAreaField) {
                // Default Matrix Form contents where to target the first child of sq-form-question-text, that is sq-form-question-title
                const textAreaLabel = textAreaField.closest('.sq-form-question-text').firstElementChild;
                // textarea doesn't accept have value attr and Vanilla JS doesn't manage state to check dynamically changing values
                if (textAreaField !== null && textAreaField.placeholder) {
                    // Equivalent to :placeholder-shown
                    textFieldLabel.classList.remove('placeholder--none');
                    textAreaLabel.classList.add('placeholder--shown');
                    textAreaField.style.borderColor = '#727683';
                } else {
                    // Reset styles when placeholder is not shown
                    textAreaLabel.classList.remove('placeholder--shown');
                    textFieldLabel.classList.add('placeholder--none');
                }
            }

            // If there is a value after submission and validation, don't fire floating label
            if (textAreaField !== null && textAreaField.value.trim() !== '') {
                const textAreaLabel = textAreaField.closest('.sq-form-question-text').firstElementChild;
                textAreaLabel.classList.add('label--focus');
                textAreaLabel.style.fontSize = '12px';
                textAreaLabel.style.lineHeight = '1';
                textAreaField.style.borderColor = '#0b1c46';
            }

            function updateTextAreaFieldLabel() {
                const textAreaLabel = textAreaField.closest('.sq-form-question-text').firstElementChild;
                textAreaLabel.classList.add('label--focus');
                textAreaField.style.borderColor = '#0b1c46';

                if ((textAreaField !== null || document.activeElement === textAreaField) && textAreaField.placeholder !== '') {
                    textAreaLabel.classList.remove('placeholder--shown');
                    textAreaLabel.style.fontSize = '12px';
                    textAreaLabel.style.color = '#0b1c46';
                } else {
                    textAreaLabel.style.textTransform = 'initial';
                    textAreaLabel.style.fontWeight = '400';
                    textAreaLabel.style.letterSpacing = '0';
                    textAreaLabel.style.position = 'relative';
                }
            }

            if (textAreaField !== null) {
                // Event listeners
                textAreaField.addEventListener('focus', updateTextAreaFieldLabel);
                textAreaField.addEventListener('input', updateTextAreaFieldLabel);
                textAreaField.addEventListener('blur', updateTextAreaFieldLabel);
            }
        });
    }

    if (formEmailInput) {
        formEmailInput.forEach((emailInput) => {
            const textField = emailInput.querySelector('input[type="text"]');
            const textFieldLabel = emailInput.querySelector('label');

            // input[type="text"] Case
            if (textField !== null && (textField.value !== null || textField.value !== '' || textField.value !== undefined) && textField.placeholder) {
                // Equivalent to :placeholder-shown
                textFieldLabel.classList.add('placeholder--shown');
                textField.style.borderColor = '#727683';
            } else {
                // Reset styles when placeholder is not shown
                textFieldLabel.classList.remove('placeholder--shown');
                textFieldLabel.classList.add('placeholder--none');
            }

            // If there is a value after submission and validation, don't fire floating label
            if (textField !== null && textField.value.trim() !== '') {
                textFieldLabel.classList.add('label--focus');
                textFieldLabel.style.fontSize = '12px';
                textFieldLabel.style.lineHeight = '1';
                textField.style.borderColor = '#0b1c46';
            }

            function updateTextFieldLabel() {
                if (((textField !== null && textField.value.trim() !== '') || document.activeElement === textField) && textField.placeholder !== '') {
                    textFieldLabel.classList.add('label--focus');
                    textFieldLabel.classList.remove('placeholder--shown');
                    textField.style.borderColor = '#0b1c46';
                }
            }

            if (textField !== null) {
                // Event listeners
                textField.addEventListener('focus', updateTextFieldLabel);
                textField.addEventListener('input', updateTextFieldLabel);
                textField.addEventListener('blur', updateTextFieldLabel);
            }
        });
    }
}
